import "core-js/stable";
import "regenerator-runtime/runtime";
import "intersection-observer"; // Optional
import Vue from "vue";
import VueHtmlWrapper from "vue-html-to-paper";
import BackToTop from "vue-backtotop";
import VueProgressBar from "vue-progressbar";
import VueClipboard from "vue-clipboard2";
import VueCookies from "vue-cookies";
import VueAnalytics from "vue-ua";
import VueCarousel from 'vue-carousel';
import { ModalPlugin, ToastPlugin } from "bootstrap-vue";
import Modal from "@/components/info-modal";
import LoginModal from "@/components/login-modal";
import MainLoader from "@/components/main-loader";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/fonts/VINfonts.css";
import "@/assets/css/custom.css";
import "@/assets/scss/vetquest-admin.css";
import "@/assets/icomoon/style.css";
import '@fortawesome/fontawesome-free/css/all.css';

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"]
};

Vue.use(VueHtmlWrapper, options);

 
Vue.use(VueCarousel);

const loaderStyle = {
  color: "#f1c151",
  failedColor: "red",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
};

Vue.use(VueProgressBar, loaderStyle);
Vue.use(BackToTop);
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(VueClipboard);
Vue.use(Modal);
Vue.use(LoginModal);
Vue.use(MainLoader);
Vue.use(VueCookies);

// Google Analytics
Vue.use(VueAnalytics, {
  appName: process.env.PACKAGE_NAME, // App name
  appVersion: process.env.PACKAGE_VERSION, // Version of the app
  trackingId: process.env.VUE_APP_TRACKING_ID, // Google Analytics Tracking ID
  debug: process.env.VUE_APP_DEBUG === "true" // Whether or not display console logs (optional)
});

// set default config
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
